import { Point } from 'leaflet';

export function mapClickedLocationAttribute(value: unknown) {
  if (value === null || typeof value !== 'string') return null;
  const [x, y] = value.split(',').map((v) => parseFloat(v));
  return new Point(x, y);
}
